import React from 'react';
import {Card, Grid, Tooltip, Typography} from "@material-ui/core";
import {Heading24} from "../../components";
import {transfer} from "../../assets/images/images";
import Button from "@material-ui/core/Button";


const data = [
  {title: 'bank transfer', icon: transfer},
  {title: 'credit card', icon: transfer},
  {title: 'COD', icon: transfer, text: 'cash on delivery'},
  // {title: 'COD', icon: transfer},
  // {title: 'COD', icon: transfer},
]

function PaymentSection(props) {
  const {paymentMethod = 'COD', setPaymentMethod, addOrder} = props;
  return (
    <Grid item lg={6} md={7} style={{backgroundColor: ''}} className='pl-10 pr-10'>

      <Heading24 title={'Payment'}/>

      <Grid container direction={'row'} justify={''} lg={12}>
        {data.map((item, index) => {
          return (
            <Tooltip title={item?.text || item.title} arrow>

              <Card
                key={index + item}
                style={{
                  backgroundColor: paymentMethod === item.title ? '#FFF0DF' : '',
                  opacity: paymentMethod !== item.title && .5
                }}
                className='  payment-card-container cursor-pointer'
                // onClick={() => {
                //   item.title !== 'credit card' && setPaymentMethod(item.title)
                // }}

              >
                <div className='display-flex  flex-column align-items-center '>
                  <img src={item.icon} alt={''} style={{alignText: 'center'}} width={40}/>
                  <Typography className={'m-0 p-0 heading-color text-capitalize'} gutterBottom variant="h6"
                              component="div">
                    {item.title}
                  </Typography>
                </div>
              </Card>
            </Tooltip>

          )
        })}

      </Grid>

      <Grid container spacing={2} className='mt-30 mb-20 pl-10  pr-10'>
        <Grid item lg={12} md={8} xs={12} className='display-flex '>
          <Button type="submit" fullWidth variant="contained" color="primary"
                  onClick={(e) => addOrder(e)}
          >
            Place order
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default PaymentSection;
